import { AppletFrame, Specs } from '@doxyme/extensions-bridge-react';
import { useExtensionsOverlayApplet } from '../../../hooks/useExtensions/useExtensionsOverlayApplet';
import Box from '@mui/material/Box';
import { Spinner } from '@doxyme/ui-foundation/components/spinner';
import { useExtensionsOverlayAppletStyles } from './extensionsOverlayApplet.styles';

import type { JSX } from 'react';

import Variant = Specs.OverlayApplet.Variant;

/**
 * This component is responsible for rendering the active overlay applet.
 */
export function ExtensionsOverlayApplet(): JSX.Element | null {
  const { applet, isLoaded } = useExtensionsOverlayApplet();

  const styles = useExtensionsOverlayAppletStyles(applet?.variant);

  if (!applet) {
    return null;
  }

  const getVariantLoader = (variant?: Variant): JSX.Element | null => {
    switch (variant) {
      case Variant.Modal: {
        return <Spinner size={64} mode='white' />;
      }
      default: {
        return null;
      }
    }
  };

  return (
    <Box css={styles.container}>
      {!isLoaded && getVariantLoader(applet.variant)}
      <AppletFrame
        applet={applet.frame}
        display={isLoaded ? 'block' : 'none'}
      />
    </Box>
  );
}
